import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { Form, actions } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import { runupSearchModel, toSearchParameters } from './runupSearchModel';
import {
  searchRunups as searchRunupsAc,
  clearRunupSearch as clearRunupSearchAc,
  getRegions as getRegionsAc,
  getCountries as getCountriesAc,
  getAreas as getAreasAc,
  getRunupAreas as getRunupAreasAc,
  getRunupRegions as getRunupRegionsAc,
  getRunupCountries as getRunupCountriesAc,
  getRunupMeasurementTypes as getRunupMeasurementTypesAc,
  getCauses as getCausesAc,
  getValidity as getValidityAc,
} from '../../../../../../redux/tsunamis/runups/search/runupSearchActions';
import { Loading } from '../../../../../loadbar/Loading';
import { withUser } from '../../../../../auth/withUser';
import { isDataManager } from '../../../../../../role/roleUtils';
import { MinMaxSearchCard } from '../../../../../form/search/MinMaxSearchCard';
import { MinMaxSelectSearchCard } from '../../../../../form/search/MinMaxSelectSearchCard';
import { TextMatchSearchCard } from '../../../../../form/search/TextMatchSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';
import { EffectsSearchCard } from '../../../../../form/search/EffectsSearchCard';


const model = runupSearchModel.get('name');

class RunupSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Runup Search';
    const {
      clearRunupSearch, getRegions, getCountries, getRunupRegions, getRunupCountries, getRunupMeasurementTypes, getCauses, getValidity, history,
      getAreas, selectedTsCountry, getRunupAreas, selectedRunupCountry,
    } = this.props;
    clearRunupSearch();
    getRegions({ history });
    getCountries({ history });
    getRunupRegions({ history });
    getRunupCountries({ history });
    getRunupMeasurementTypes({ history });
    getCauses({ history });
    getValidity({ history });
    if (selectedTsCountry) {
      getAreas({ country: selectedTsCountry, history });
    }
    if (selectedRunupCountry) {
      const selectedRunupCountrySplit = selectedRunupCountry.split(';').map(s => s.trim());
      getRunupAreas({ country: selectedRunupCountrySplit[0], history });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      change,
      selectedTsCountry,
      selectedTsArea,
      selectedRunupCountry,
      selectedRunupArea,
      getAreas,
      getRunupAreas,
      history,
    } = this.props;
    const {
      selectedTsCountry: prevSelectedTsCountry,
      selectedRunupCountry: prevSelectedRunupCountry,
    } = prevProps;

    const prevSelectedRunupCountrySplit = prevSelectedRunupCountry.split(';').map(s => s.trim());
    const selectedRunupCountrySplit = selectedRunupCountry.split(';').map(s => s.trim());

    if (prevSelectedTsCountry !== selectedTsCountry) {
      if (selectedTsArea) change('.sourceArea', '');
      if (selectedTsCountry) {
        getAreas({ country: selectedTsCountry, history });
      }
    }

    if (prevSelectedRunupCountrySplit[0] !== selectedRunupCountrySplit[0]) {
      if (selectedRunupArea) change('.area', '');
      if (selectedRunupCountry) {
        getRunupAreas({ country: selectedRunupCountrySplit[0], history });
      }
    }
  }

  handleSubmit(form) {
    const { searchRunups, history } = this.props;
    const queryParameters = toSearchParameters(form);
    const location = {
      pathname: '/view/hazards/tsunami/runup-data',
      search: qs.stringify(toSearchParameters(form), { skipNulls: true }),
    };
    searchRunups({
      queryParameters, formModel: model, history, location, searchRedirect: true,
    });
  }

  render() {
    const {
      resetForm,
      searching,
      fetched,
      regions,
      countries,
      areas,
      fetchingAreas,
      runupAreas,
      runupRegions,
      runupCountries,
      fetchingRunupAreas,
      runupMeasurementTypes,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      authorities,
    } = this.props;

    if (!fetched || searching) {
      return (<Loading />);
    }

    const regionsJs = regions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();
    const validitiesJs = validities.toJS();
    const causesJs = causes.toJS();
    const dataManager = isDataManager(authorities);
    const runupRegionsJs = runupRegions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const oceanicTsunamiJs = [{ id: 'true', description: 'Yes = Oceanic tsunami indicates the tsunami originated in an ocean body.' }, { id: 'false', description: 'No = disturbance or tsunami waves originated in an inland river/lake.' }];

    return (
      <div className="haz-results-container haz-page-container">

        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Runups</CardTitle>
            <p>
              The NCEI/WDS Global Historical Tsunami Database contains
              runup information on locations where tsunami effects were observed.
              The tsunami runup data is related to the tsunami source data
              which contains information on the source of the tsunami.
              Please see the
              {' '}
              <a href="https://www.ngdc.noaa.gov/hazard/tsunami-db-intro.html" rel="noopener noreferrer" target="_blank" title="World-Wide Tsunamis Introduction" aria-label="World-Wide Tsunamis Introduction">tsunami introduction</a>
              {' '}
              for more information on the NOAA/WDS tsunami database as well as our
              {' '}
              <a href="https://maps.ngdc.noaa.gov/viewers/hazards/?layers=1" rel="noopener noreferrer" target="_blank" title="Natural Hazards Viewer" aria-label="Natural Hazards Viewer">map viewer.</a>
            </p>
            <p>
              Please cite as:
              <br />
              {' '}
              <b>
                National Geophysical Data Center / World Data Service: NCEI/WDS Global Historical Tsunami Database. NOAA National Centers for Environmental Information.
                {' '}
                <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Tsunami Runup DOI Information" aria-label="Tsunami Runup DOI Information">doi:10.7289/V5PN93H7</a>
              </b>
            </p>
            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              { dataManager && (
                <Card>
                  <CardBody>
                    <CardTitle tag="h2">Runup ID</CardTitle>
                    <LabeledText model=".id" label="ID" />
                    <MinMaxSearchCard min=".minId" max=".maxId">ID Range</MinMaxSearchCard>
                  </CardBody>
                </Card>
              )}

              { dataManager && (
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Event ID</CardTitle>
                  <LabeledText model=".tsunamiEventId" label="Tsunami Event" />
                  <MinMaxSearchCard min=".minEventId" max=".maxEventId">ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>
              )}

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Source Information</CardTitle>
                  { dataManager && (
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".sourceMonth" label="Month" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".sourceDay" label="Day" />
                  </div>
                  )}
                  <MinMaxSearchCard min=".sourceMinYear" max=".sourceMaxYear" helpModalId="year">Year</MinMaxSearchCard>

                  <div className="form-row">
                    <LabeledSelect childOptions={regionsJs} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="sourceRegionCode" label="Region" multiselect filterable helpModalId="tsuRegion" />
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="sourceCountry" label="Country" filterable readOnly={fetchingAreas} helpModalId="tsuCountry" />
                    <LabeledSelect childOptions={areas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="sourceArea" label="Area" filterable readOnly={fetchingAreas || !areas.size} helpModalId="tsuArea" />
                  </div>

                  <MinMaxSelectSearchCard model={model} minField="sourceMinEventValidity" maxField="sourceMaxEventValidity" descriptors={validitiesJs} prependId helpModalId="tsuValidity">Source Validity</MinMaxSelectSearchCard>
                  <MinMaxSelectSearchCard model={model} minField="sourceMinCauseCode" maxField="sourceMaxCauseCode" descriptors={causesJs} prependId helpModalId="tsuCauseCode">Cause of Tsunami</MinMaxSelectSearchCard>
                  <Card>
                    <CardBody>
                      <div className="form-row">
                        <LabeledSelect childOptions={oceanicTsunamiJs} formGroupClassName={['col-6']} parentModel={model} fieldId="sourceOceanicTsunami" label="Oceanic Tsunami" sorted={false} helpModalId="tsuOceanicTsunami" />
                      </div>
                    </CardBody>
                  </Card>
                  <MinMaxSearchCard min=".sourceMinEqMagnitude" max=".sourceMaxEqMagnitude" helpModalId="eqMagnitude">Earthquake Magnitude</MinMaxSearchCard>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Runup Location Information</CardTitle>
                  <div className="form-row">
                    <LabeledSelect childOptions={runupRegionsJs} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="regionCode" label="Region" multiselect filterable helpModalId="ruRegion" />
                    <LabeledSelect childOptions={runupCountries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="country" label="Country" multiselect filterable readOnly={fetchingRunupAreas} helpModalId="ruCountry" splitString=";" />
                    <LabeledSelect childOptions={runupAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="area" label="Area" filterable readOnly={fetchingRunupAreas || !runupAreas.size} helpModalId="ruArea" />
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.locationSearchType"
                    textModel=".radios.loc"
                    startsWith="locStart"
                    includes="locInclude"
                    matches="locMatch"
                    doesNotMatch="locNot"
                    helpModalId="ruLocation"
                  >
                    Location
                  </TextMatchSearchCard>
                  <LatLongSearchCard helpModalIdPrefix="tsu" model={model} />
                  <div className="form-row row-margin-fix">
                    <MinMaxSearchCard className="col-md-6" min=".minDistFromSource" max=".maxDistFromSource" helpModalId="ruDistance">Distance From Source (km)</MinMaxSearchCard>
                    <MinMaxSearchCard className="col-md-6" min=".minTravHours" max=".maxTravHours" helpModalId="ruWaveTravelHour">Travel Time (Hours)</MinMaxSearchCard>
                  </div>


                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Runup Parameters</CardTitle>

                  <div className="form-row row-margin-fix">
                    <LabeledSelect childOptions={runupMeasurementTypes.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} multiselect={dataManager} fieldId="typeMeasurementId" label="Type of Measurement" sorted={false} prependId helpModalId="ruMeasurementType" />

                    <LabeledSelect
                      formGroupClassName={['col-lg-8']}
                      parentModel={model}
                      fieldId="doubtful"
                      label="Doubtfulness"
                      sorted={false}
                      unselectedText="Select Doubtfulness"
                      helpModalId="ruDoubtful"
                      multiselect={dataManager}
                      childOptions={[
                        { id: 'n', description: 'OK' },
                        { id: 'y', description: 'Doubtful' },
                        { id: 'm', description: 'Meteorological' },
                        { id: 'a', description: 'Atmospheric' },
                      ]}
                    />
                  </div>

                  <div className="form-row row-margin-fix">
                    <MinMaxSearchCard className="col-md-4" min=".minRunupHt" max=".maxRunupHt" helpModalId="ruHeight">Water Height (m)</MinMaxSearchCard>
                    { dataManager && (
                    <MinMaxSearchCard className="col-md-4" min=".minTroughHt" max=".maxTroughHt" helpModalId="ruTroughHt">Max Trough Height (m)</MinMaxSearchCard>
                    )}
                    <MinMaxSearchCard className="col-md-4" min=".minRunupHoriz" max=".maxRunupHoriz" helpModalId="ruInundation">Max Inundation Distance (m)</MinMaxSearchCard>
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.commentsSearchType"
                    textModel=".radios.comments"
                    startsWith="commentsStart"
                    includes="commentsInclude"
                    matches="commentsMatch"
                    doesNotMatch="commentsNot"
                    helpModalId="ruComments"
                  >
                    Comments
                  </TextMatchSearchCard>

                </CardBody>
              </Card>

              <EffectsSearchCard
                helpModalIdPrefix="ru"
                deaths
                injuries
                damage
                housedDestroyed
                housedDamaged
                model={model}
                peopleDescriptors={peopleDescriptorsJs}
                damageDescriptors={damageDescriptorsJs}
                housesDescriptors={housesDescriptorsJs}
              >
                Runup Effects
              </EffectsSearchCard>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

RunupSearchPageUnwrapped.propTypes = {
  searchRunups: PropTypes.func.isRequired,
  clearRunupSearch: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  selectedTsCountry: PropTypes.string.isRequired,
  selectedTsArea: PropTypes.string.isRequired,
  selectedRunupCountry: PropTypes.string.isRequired,
  selectedRunupArea: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getAreas: PropTypes.func.isRequired,
  getRunupRegions: PropTypes.func.isRequired,
  getRunupCountries: PropTypes.func.isRequired,
  getRunupAreas: PropTypes.func.isRequired,
  getRunupMeasurementTypes: PropTypes.func.isRequired,
  getValidity: PropTypes.func.isRequired,
  getCauses: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
  fetchingAreas: PropTypes.bool.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  areas: ImmutablePropTypes.list.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  runupCountries: ImmutablePropTypes.list.isRequired,
  runupAreas: ImmutablePropTypes.list.isRequired,
  fetchingRunupAreas: PropTypes.bool.isRequired,
  runupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  validities: ImmutablePropTypes.list.isRequired,
  causes: ImmutablePropTypes.list.isRequired,
  history: PropTypes.shape({}).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  searching: state.getIn(['runupSearchPage', 'searching']),
  selectedTsCountry: state.getIn([model, 'sourceCountry']),
  selectedTsArea: state.getIn([model, 'sourceArea']),
  selectedRunupCountry: state.getIn([model, 'country']),
  selectedRunupArea: state.getIn([model, 'area']),
  fetched: [
    state.getIn(['runupSearchPage', 'fetchedRegions']),
    state.getIn(['runupSearchPage', 'fetchedCountries']),
    state.getIn(['runupSearchPage', 'fetchedRunupRegions']),
    state.getIn(['runupSearchPage', 'fetchedRunupCountries']),
    state.getIn(['runupSearchPage', 'fetchedRunupMeasurementTypes']),
    state.getIn(['runupSearchPage', 'fetchedValidities']),
    state.getIn(['runupSearchPage', 'fetchedCauses']),
  ].every(v => v),
  fetchingAreas: state.getIn(['runupSearchPage', 'fetchingAreas']),
  regions: state.getIn(['runupSearchPage', 'regions']),
  countries: state.getIn(['runupSearchPage', 'countries']),
  areas: state.getIn(['runupSearchPage', 'areas']),
  runupRegions: state.getIn(['runupSearchPage', 'runupRegions']),
  runupCountries: state.getIn(['runupSearchPage', 'runupCountries']),
  runupAreas: state.getIn(['runupSearchPage', 'runupAreas']),
  fetchingRunupAreas: state.getIn(['runupSearchPage', 'fetchingRunupAreas']),
  runupMeasurementTypes: state.getIn(['runupSearchPage', 'runupMeasurementTypes']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
  validities: state.getIn(['runupSearchPage', 'validities']),
  causes: state.getIn(['runupSearchPage', 'causes']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchRunups: searchRunupsAc,
  clearRunupSearch: clearRunupSearchAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  getRegions: getRegionsAc,
  getCountries: getCountriesAc,
  getAreas: getAreasAc,
  getRunupRegions: getRunupRegionsAc,
  getRunupCountries: getRunupCountriesAc,
  getRunupAreas: getRunupAreasAc,
  getRunupMeasurementTypes: getRunupMeasurementTypesAc,
  getValidity: getValidityAc,
  getCauses: getCausesAc,
}, dispatch);

export const RunupSearchPage = withUser(connect(mapStateToProps, mapDispatchToProps)(RunupSearchPageUnwrapped));
